import React, { createRef } from "react";
import { BillWatchLayout } from "../BillWatchLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchProps } from "../BillWatchProps";
import { NSBox, NSButtonGreen, NSLine, NSPanel, NSRow, NSSection } from "namirasoft-site-react";
import ConditionLine from "../components/ConditionLine";
import { CostData, FormulaRow, Formulas } from "namirasoft-bill-watch";
import { BillWatchSampleData } from "../BillWatchSampleData";
import BatchSimulationLine from "../components/BatchSimulationLine";

interface RuleBastionSimulationPageProps extends NSARouterMakerResult, BillWatchProps { }

interface RuleBastionSimulationPageState
{
	formula: FormulaRow | null;
}

class RuleBastionSimulationPage extends React.Component<RuleBastionSimulationPageProps, RuleBastionSimulationPageState>
{
	ConditionLine_Simulate = createRef<ConditionLine>();

	constructor(props: RuleBastionSimulationPageProps)
	{
		super(props);
		this.state = {
			formula: null,
		};
	}

	override render()
	{
		return (
			<BillWatchLayout
				{...this.props}
                action={{
                    title: "Batch Simulation",
                    description: "You can enter a formula, change type, and threshold. The system will simulate this condition using multiple sample data sets so you can see potential outcomes."
                }}
			>
				<NSSection>
					<NSPanel>
						<NSRow
							style={{ width: NSBox.width.triple }}
						>
							<ConditionLine
								ref={this.ConditionLine_Simulate}
								{...this.props}
								deletable={false}
								index={null}
								onDelete={() => { }}
								required
								nullable={false}
							></ConditionLine>
							<NSLine />
							<NSRow
								style={{ alignItems: "end" }}
							>
								<NSButtonGreen
									title="Simulate"
									onClick={{
										action: () =>
										{
											try
											{
												let formula = this.ConditionLine_Simulate.current?.getValue();
												if (formula)
													this.setState({ formula });
											} catch (error)
											{
												this.setState({ formula: null });
												this.props.notifier.onError(error as Error);
											}
										},
										showLoading: false
									}}
								/>
							</NSRow>
							<NSLine />
							<NSRow>
								{
									this.state.formula &&
									Object.keys(BillWatchSampleData.List).map(name =>
									{
                                        let all: CostData[] = BillWatchSampleData.List[name].map(r => ({ amount: r, time: "", unit: "" }) );
										let { data, value } = Formulas.getDataValue(all, all[0]);
										return <BatchSimulationLine
											name={name}
											data={data}
											value={value}
											formula={this.state.formula as FormulaRow}
											result={Formulas.evaluate(data, value, this.state.formula as FormulaRow, true)}
										/>
									}
									)
								}
							</NSRow>
						</NSRow>
					</NSPanel>
				</NSSection>
			</BillWatchLayout>
		);
	}
}

export default RuleBastionSimulationPage;